import React from "react"
import Select from "react-select"
import { useFormikContext } from "formik"
import { COLOR_CONSTANTS } from "../../../../constants/ColorConstants.js"
import { styleValueImportant } from "../../../../app/helpers/StyleHelper"

export const TextFieldAutoComplete = ({
  name,
  label,
  options,
  required,
  value,
  placeholder,
  editable = true,
  alignItems = "center", // align-items css value
  isMulti = true,
}) => {
  const { setFieldValue, touched, errors } = useFormikContext()

  const handleChange = (selectedOptions) => {
    if (!editable) return
    if (isMulti) {
      setFieldValue(name, selectedOptions ? selectedOptions.map((opt) => opt.value) : [])
    } else {
      setFieldValue(name, selectedOptions ? [selectedOptions.value] : [])
    }      
  }

  const getValue = () => {
    if (!options || options.length === 0) return []

    if (isMulti) {
      if (Array.isArray(value)) {
        return options.filter((opt) => value.includes(opt.value))
      } else {
        return []
      }
    } else {
      if (!value || value.length === 0) return []
      const selectedOption = options.find((opt) => opt.value === value[0])
      return selectedOption ? [selectedOption] : []
    }
  }

  return (
    <div className="multi-select-container">
      <label>
        {label} {required && <span className={"text-neutral-red"}>*</span>}
      </label>

      <Select
        isMulti={isMulti}
        name={name}
        options={options}
        value={getValue() || []}
        onChange={isMulti ? handleChange : (option) => handleChange(option)}
        className="react-select-container"
        classNamePrefix="react-select"
        closeMenuOnSelect={!isMulti}
        isClearable={true}
        isDisabled={!editable}
        hideSelectedOptions={false}
        filterOption={(option, inputValue) => {
          const label = option.data?.label ? String(option.data?.label).toLowerCase() : ""
          return label.includes(inputValue.toLowerCase())
        }}
        getOptionLabel={(e) => (
          <div className="custom-option">
            {isMulti && (
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  checked={Array.isArray(value) && value?.includes(e.value)}
                  readOnly
                />
                <span className="checkmark"></span>
              </div>
            )}

            <div style={{ display: "flex", flexDirection: "column", alignItems: alignItems }}>
              <span
                className="font-black fw-normal text-neutral-black font-weight-bolder">
                {e.label}
              </span>
              {e.description && <span className="mt-1">{e.description}</span>}
            </div>
          </div>
        )}
        components={{
          SingleValue: (props) => {
            return (
              <div>
                {props?.data?.label}
              </div>
            )
          },
          MultiValueContainer: () => null,
          MultiValueRemove: () => null,
          MultiValue: (props) => {
            return (
              <div>
                {props.index !== 0 && ", "}
                {props?.data?.label}{" "}
              </div>
            )
          }
        }}
        placeholder={placeholder || ""}
        styles={{
          option: (base, state) => ({
            ...base,
            fontWeight: "normal",
            backgroundColor: state.isFocused ? COLOR_CONSTANTS.TERTIARY_SOFT : COLOR_CONSTANTS.NEUTRAL_WHITE,
            color: COLOR_CONSTANTS.NEUTRAL_BLACK,
            "&:active": {
              backgroundColor: COLOR_CONSTANTS.TERTIARY_SOFT,
              color: COLOR_CONSTANTS.NEUTRAL_BLACK
            },
            "& span": {
              color: styleValueImportant(COLOR_CONSTANTS.NEUTRAL_BLACK)
            },
            "& .mt-1": {
              color: styleValueImportant(COLOR_CONSTANTS.NEUTRAL_GRAY)
            }
          })
        }}
      />

      {isMulti && (
        <div
          className="chip-container"
          style={{ marginTop: "10px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {getValue().map((opt) => (
            <div
              key={opt.value}
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: COLOR_CONSTANTS.TERTIARY_LIGHT_GREEN,
                color: COLOR_CONSTANTS.PRIMARY_GREEN,
                padding: "6px 12px",
                borderRadius: "20px",
                fontSize: "14px",
                fontWeight: "normal",
                border: `1px solid ${COLOR_CONSTANTS.PRIMARY_GREEN}`,
              }}>
              {opt.label}
              <span
                onClick={() => handleChange(getValue().filter((item) => item.value !== opt.value))}
                style={{
                  marginLeft: "8px",
                  cursor: "pointer",
                  fontWeight: "bold"
                }}>
                ✕
              </span>
            </div>
          ))}
        </div>
      )}

      {touched[name] && errors[name] && (
        <div className="error-text" style={{ color: "red", marginTop: "5px" }}>
          {errors[name]}
        </div>
      )}
    </div>
  )
}
